// Add event listener for the app stick footer
let drawerIsOpen = false;
document.addEventListener('DOMContentLoaded', function () {
  
  const detailsMenu = document.getElementById('Details-menu-drawer-container');
  const summaryButton = detailsMenu.querySelector('summary');
  const iconContainer = document.querySelector('#custom-dtt-sticky-mobile-footer .menu-drawer-container .header__icon--menu span');

  const hamburgerButton = document.querySelector('#custom-dtt-sticky-mobile-footer .menu .icon-hamburger');
  const closeButton = document.querySelector('#custom-dtt-sticky-mobile-footer .menu .icon-close');
  
  function toggleMenuDrawer() {
    
    if (!drawerIsOpen) { // Open the drawer
      detailsMenu.setAttribute('open', ''); // Add open attribute
      detailsMenu.classList.add('menu-opening'); // Add menu-opening class
      summaryButton.setAttribute('aria-expanded', 'true'); // Set aria-expanded to true
      drawerIsOpen = !drawerIsOpen;

      hamburgerButton.style.display = 'none';
      closeButton.style.display = 'block';
      
    } else { // Close the drawer
      detailsMenu.setAttribute('close', ''); // Add open attribute
      detailsMenu.classList.remove('menu-opening'); // Add menu-opening class
      summaryButton.setAttribute('aria-expanded', 'false'); // Set aria-expanded to true
      drawerIsOpen = !drawerIsOpen;
      
      hamburgerButton.style.display = 'block';
      closeButton.style.display = 'none';
      
    };
  };
  
  const mobileButton = document.querySelector('#custom-dtt-sticky-mobile-footer .menu');
  mobileButton.addEventListener('click', toggleMenuDrawer);
});

// Ensure that the mobile search button focuses on the search bar when clicked
document.addEventListener('DOMContentLoaded', () => {
  const mobileSearchButton = document.querySelector('#custom-dtt-sticky-mobile-footer .search');
  const searchInputElement = document.querySelector('#custom-header-top-container .field .search__input');

  if (mobileSearchButton && searchInputElement) {
    mobileSearchButton.addEventListener('click', () => {
      
      // Make sure the input is enabled + visible
      searchInputElement.removeAttribute('disabled');
      searchInputElement.style.display = 'block';

      // Step 2: Scroll into view immediately (not in timeout)
      searchInputElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // open keyboard on mobile
      searchInputElement.focus();

      // select the input just in case there is already text in there
      searchInputElement.select();
    });
  }
});

// Clicking the "Swipe" button on the header
let customHeaderIsAtStart = true;
let customHeaderIsAtEnd = false;
const customDdtHeaderRow = document.querySelector('#ddt-header-menu-mobile .header__inline-menu .list-menu');
const moreHeaderItemsElement = document.querySelector('#ddt-header-menu-mobile .additional-category-arrow');
const previousHeaderItemsElement = document.querySelector('#ddt-header-menu-mobile .prior-category-arrow');
let firstLoad = true;
function scrollStatus() {
  
  // Hide left side swipe button on far left
  if (customDdtHeaderRow) {
    customHeaderIsAtStart = customDdtHeaderRow.scrollLeft <= 1;
  };

  if (customHeaderIsAtStart) {
    if (previousHeaderItemsElement) {
      previousHeaderItemsElement.style.opacity = 0;
    }
  } else {
    if (previousHeaderItemsElement) {
      previousHeaderItemsElement.style.opacity = 1;
    };
  };

  // Hide right side swipe button on far right
  if (firstLoad) {
    if (moreHeaderItemsElement) {
      moreHeaderItemsElement.style.opacity = 1;
      firstLoad = false;
    }
  } else {
    customHeaderIsAtEnd = (customDdtHeaderRow.scrollLeft + 1) + customDdtHeaderRow.clientWidth >= customDdtHeaderRow.scrollWidth - 1;
    if (customHeaderIsAtEnd) {
      if (moreHeaderItemsElement) {
        moreHeaderItemsElement.style.opacity = 0;  
      }
    } else {
      if (moreHeaderItemsElement) {
        moreHeaderItemsElement.style.opacity = 1;
      }
    };
  };
  
};
document.addEventListener('DOMContentLoaded', scrollStatus);
if (customDdtHeaderRow) {
  customDdtHeaderRow.addEventListener('scroll', scrollStatus);
};

// Clicking the right button
if (moreHeaderItemsElement) {
  moreHeaderItemsElement.addEventListener('click', () => {
    // console.log('Push row to see more');
    customDdtHeaderRow.scrollBy({
      left: 200,
      behavior: 'smooth'
    });
    
  });
};
// Clicking the left button
if (previousHeaderItemsElement) {
  previousHeaderItemsElement.addEventListener('click', () => {
    // console.log('Pull row to see previous');
    customDdtHeaderRow.scrollBy({
      left: -200,
      behavior: 'smooth'
    });
  });
};